import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AppInsightsService, IMeasurementDictionary, IPropDictionary } from './app-insights.service';

@Injectable({ providedIn: 'root' })
export class UsageAnalyticsService {
  private trackingStarted = false;

  constructor(
    private router: Router,
    private appInsights: AppInsightsService
  ) {}

  startTracking(): void {
    if (this.trackingStarted) {
      return;
    }

    this.trackingStarted = true;
    this.trackCurrentPage();

    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(() => {
      this.trackCurrentPage();
    });
  }

  trackAction(
    actionName: string,
    options?: {
      props?: IPropDictionary;
      measurements?: IMeasurementDictionary;
    }
  ): void {
    this.appInsights.trackEvent(`Usage.${actionName}`, options);
  }

  private trackCurrentPage(): void {
    const routeInfo = this.getDeepestRoute(this.router.routerState.snapshot.root);
    const pageName = this.getRouteTitle(routeInfo) || this.getRoutePath(routeInfo) || 'CRS Page';

    this.appInsights.trackPageView({
      pageName,
      url: this.stripQueryString(this.router.url),
      routeInfo,
      props: {
        RoutePath: this.getRoutePath(routeInfo),
      },
    });
  }

  private getDeepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = route;

    while (current.firstChild) {
      current = current.firstChild;
    }

    return current;
  }

  private getRouteTitle(route: ActivatedRouteSnapshot): string {
    return String(route.data?.['title'] ?? '');
  }

  private getRoutePath(route: ActivatedRouteSnapshot): string {
    const path = route.pathFromRoot
      .map((snapshot) => snapshot.routeConfig?.path)
      .filter((segment): segment is string => !!segment)
      .join('/');

    return path ? `/${path}` : '/';
  }

  private stripQueryString(url: string): string {
    return url.split('?')[0] ?? url;
  }
}
